import { IconButton } from '@creditornot/cb-button';
import { Cross } from '@creditornot/cb-icons';
import { cbSemanticCssVars } from '@creditornot/cb-ingredients';
import { Empty } from '@creditornot/cb-placeholders';
import { Spinner } from '@creditornot/cb-progress';
import React, { ReactNode } from 'react';
import { useIntl } from 'react-intl';
import styled from 'styled-components';

import { Typography as T } from 'common/typography';

import ItemList from './ItemList';
import { ItemData, ListElement } from '../types';

type Props = {
  items: ListElement[];
  isLoadingItems: boolean;
  menuId: string | null;
  draggedItemIds: string[] | undefined;
  header: ReactNode;
  onClose: () => void;
  onMoveItems: (itemsData: ItemData[]) => void;
};

const Root = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 64px;
  padding: 20px 24px;
  border-block-end: 1px solid ${cbSemanticCssVars.borderPrimary};
`;

const Content = styled.div`
  flex: 1;
  overflow: auto;
  display: flex;
  flex-direction: column;
`;

const SpinnerContainer = styled.div`
  width: 100%;
  text-align: center;
  margin-block-start: 32px;
`;

const StyledEmpty = styled(Empty)`
  margin-block-start: 32px;
`;

const UnassignedArea = ({ items, isLoadingItems, menuId, draggedItemIds, header, onClose, onMoveItems }: Props) => {
  const intl = useIntl();
  return (
    <Root>
      <Header>
        <T.Heading6>{header}</T.Heading6>
        <IconButton variant="neutral" size="small" onClick={onClose}>
          <Cross />
        </IconButton>
      </Header>
      <Content>
        {isLoadingItems && (
          <SpinnerContainer>
            <Spinner size="large" />
          </SpinnerContainer>
        )}
        {!isLoadingItems && items.length === 0 && (
          <StyledEmpty
            title={intl.formatMessage({ id: 'picking-route.empty-placeholder-title' })}
            description={intl.formatMessage({ id: 'picking-route.no-unassigned' })}
          />
        )}
        {!isLoadingItems && items.length > 0 && (
          <ItemList items={items} menuId={menuId} draggedItemIds={draggedItemIds} onMoveItems={onMoveItems} />
        )}
      </Content>
    </Root>
  );
};

export default UnassignedArea;
